"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.avatar.setup.title': 'Configurar Su Avatar',
    'onboarding.avatar.config.title': 'Configuración del Avatar',
    'onboarding.avatar.name.label': 'Nombre del Avatar',
    'onboarding.avatar.name.placeholder': 'Ingrese el nombre del avatar',
    'onboarding.avatar.name.required': '*',
    'onboarding.avatar.age.label': 'Edad del Avatar',
    'onboarding.avatar.age.placeholder': 'Ingrese la edad del avatar',
    'onboarding.avatar.gender.label': 'Género del Avatar',
    'onboarding.avatar.gender.placeholder': '-- Seleccionar Género --',
    'onboarding.avatar.gender.male': 'Masculino',
    'onboarding.avatar.gender.female': 'Femenino',
    'onboarding.avatar.voice.label': 'Voz del Avatar',
    'onboarding.avatar.voice.placeholder': '-- Seleccionar Voz --',
    'onboarding.avatar.voice.loading': 'Cargando voces...',
    'onboarding.avatar.voice.select_gender_first': 'Por favor selecciona género primero',
    'onboarding.avatar.voice.male': 'Masculina',
    'onboarding.avatar.voice.female': 'Femenina',
    'onboarding.avatar.description.label': 'Descripción del Avatar',
    'onboarding.avatar.description.placeholder': 'Describa la personalidad y características de su avatar',
    'onboarding.avatar.image.label': 'Imagen del Avatar',
    'onboarding.avatar.image.placeholder': 'Subir imagen del avatar...',
    'onboarding.avatar.name': 'Nombre del Avatar',
};
